import Markdown from "@uiw/react-markdown-preview";
import '@uiw/react-markdown-preview/markdown.css'
import 'github-markdown-css/github-markdown.css'
import "./markdown-editor.css"

import { TAB } from '../utils/constants'
import RawPreview from './RawPreview'
import { useEffect } from "react";

export const PreviewColumn = ({
  selectedSectionSlugs,
  getTemplate,
  selectedTab,
  setMarkdown,
  language,
}) => {
  const uniqueSlugs = [...new Set(selectedSectionSlugs)]

  const markdown = uniqueSlugs.reduce((acc, section) => {
    const template = getTemplate(section)
    return template ? `${acc}\n${template.markdown}` : acc
  }, '')

   // Determine direction based on language
   const isRTL = language === 'ur' // Only Urdu is RTL among common options

  // Automatically send current markdown to parent whenever it changes
  useEffect(() => {
    if (markdown.trim()) {
      setMarkdown(markdown);
    } else {
      setMarkdown('');
    }
  }, [markdown, setMarkdown]);
  const showPreview = selectedTab === TAB.PREVIEW


  // if (!markdown.trim()) {
  //   return (
  //     <div className="h-full flex items-center justify-center text-gray-500">
  //       No content selected
  //     </div>
  //   )
  // }

  return (
    <div
      className={`h-full md:w-[35vw] w-full border border-gray-300 rounded-md p-0 bg-white full-screen 
      overflow-x-scroll md:overflow-x-auto 
      ${showPreview ? 'overflow-y-scroll' : 'overflow-hidden'}
      ${isRTL ? 'text-right' : 'text-left'}`}
      dir={isRTL ? 'rtl' : 'ltr'}

    >
      {showPreview ? (
        <Markdown
          source={markdown || "No content selected"}
          enablePreview={true}
          className="markdown-body"
          style={{
            backgroundColor: 'transparent',
            padding: 6,
          }}
        />
      ) : (
        <RawPreview text={markdown || "No content selected"} />
      )}
    </div>
  )
}
